import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import { EntityRoutes } from 'routes/constants';
import strings from 'strings';
import FPHtmlViewer from 'UI/components/atoms/FPHtmlViewer';

import { PlainLink } from '../../shared';
import { PRESENTATION_TYPES } from '../constants';
import { DetailPanelLayout } from '../DetailPanelLayout';
import { ListItemIconOption, ListItemOption } from '../styles';

const COPIES = strings.ai.generators.presentationsMaker;

const CANDIDATES_PRESENTATION_TYPES_IDS = [
  'call',
  'sms',
  'linkedinPrompt',
  'industryBriefing',
  'bulk'
];

const CANDIDATES_PRESENTATION_TYPES = PRESENTATION_TYPES.filter(type => {
  const isEnabled = type?.isEnabled ? type.isEnabled() : true;
  return CANDIDATES_PRESENTATION_TYPES_IDS.includes(type.id) && isEnabled;
});

export const CandidatePresentationTypeSelector = ({
  candidate,
  isEnabled,
  onSelectPresentationType
}) => {
  const [selectedPresentationType, setSelectedPresentationType] = useState(null);

  const handlePresentationTypeSelect = id => {
    setSelectedPresentationType(id);
    onSelectPresentationType && onSelectPresentationType(id);
  };

  const company = {
    id: candidate?.company_id,
    name: candidate?.current_company,
    location: candidate?.companyLocation
  };
  const { personalInformation } = candidate || {};
  const { full_name: fullName } = personalInformation || {};
  const { address } = personalInformation || {};
  const { specialty } = candidate || {};
  const location = address && `${address?.address}, ${address?.city?.state?.title}`;

  return (
    <DetailPanelLayout
      header={
        <FPHtmlViewer
          content={strings.formatString(COPIES.candidates.header, {
            candidateName: fullName
          })}
        />
      }
      body={CANDIDATES_PRESENTATION_TYPES.map(({ id, Icon, name }) => (
        <Grid item key={id} xs={12}>
          <List>
            <ListItemOption
              button
              disabled={!isEnabled}
              onClick={_event => handlePresentationTypeSelect(id)}
              selected={selectedPresentationType === id}
            >
              <ListItemIconOption>
                <Icon />
              </ListItemIconOption>

              {name}
            </ListItemOption>
          </List>
        </Grid>
      ))}
      footer={
        <>
          <Typography variant="subtitle1">
            {strings.formatString(COPIES.candidates.candidateToPresent, {
              candidateName: fullName
            })}
          </Typography>
          <Typography variant="body2">{candidate?.email}</Typography>
          <Typography variant="body2">{location}</Typography>
          <Typography variant="body1">{`${candidate?.title} / ${specialty?.industry?.title}: ${specialty?.title}`}</Typography>
          <PlainLink
            itemId={company.id}
            aria-label="Company Name"
            linkProps={{
              type: 'local',
              url: EntityRoutes.CompanyProfile,
              target: '_blank'
            }}
            noWrap
          >
            {company.name}
          </PlainLink>
          {company?.location && <Typography paragraph={false}>{company?.location}</Typography>}
        </>
      }
    />
  );
};
